import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const deleteViewTemplate = gql`
  mutation DeleteViewTemplateMutation($input: DeleteViewTemplate!) {
    deleteViewTemplate(input: $input)
  }
`;

export const updateViewTemplate = gql`
  mutation UpdateViewTemplateMutation($input: UpdateViewTemplate!) {
    updateViewTemplate(input: $input) {
      ...ViewTemplate
    }
  }

  ${Fragments.viewTemplate.ViewTemplate}
`;

export const createViewTemplate = gql`
  mutation CreateViewTemplateMutation($input: CreateViewTemplate!) {
    createViewTemplate(input: $input) {
      ...ViewTemplate
    }
  }

  ${Fragments.viewTemplate.ViewTemplate}
`;

export const duplicateViewTemplate = gql`
  mutation DuplicateViewTemplateMutation($input: DuplicateViewTemplate!) {
    duplicateViewTemplate(input: $input) {
      ...ViewTemplate
    }
  }

  ${Fragments.viewTemplate.ViewTemplate}
`;

export const createViewTemplateLayout = gql`
  mutation CreateViewTemplateLayoutMutation($input: CreateViewTemplateLayout!) {
    createViewTemplateLayout(input: $input) {
      ...ViewTemplateLayout
    }
  }

  ${Fragments.viewTemplate.ViewTemplateLayout}
`;

export const updateViewTemplateLayout = gql`
  mutation UpdateViewTemplateLayoutMutation($input: UpdateViewTemplateLayout!) {
    updateViewTemplateLayout(input: $input) {
      ...ViewTemplateLayout
    }
  }

  ${Fragments.viewTemplate.ViewTemplateLayout}
`;
